<template>
  <section class="news-container">
    <section class="Product">
      <div class="header">
        <span class="title">Homepage  Banner</span>
      </div>
      <div  class="content-container">
        <section
          ref="sortableBanner"
          class="content-container"
        >
          <div
            v-for="(item) in detailProductList"
            :key="item.id"
            class="item">
            <div
              class="img"
              @click="routerToProductPromoDetail(item)">
              <img :src="item.preview_url">
            </div>
            <div class="footer">
              <div class="info">
                <span
                  class="top-tag"
                >{{item.status==1?'ON':'OFF'}}</span>
                <p class="time mg-t-3">{{item.period}}</p>
              </div>
              <span
                class="icon"
                @mousedown="handleProductClick(item)"
                @mouseenter="handleProductMouseEnter"
                @mouseleave="handleProductMouseLeave">
                <font-awesome-icon icon="grip-lines" />
              </span>
            </div>
          </div>

        </section>
        <div
          v-if="detailProductList.length<5"
          class="item">
          <div
            class="img"
            @click="routerToProductPromoDetail">
            <span class="add-icon">
            </span>
          </div>

          <!--            <div class="footer">-->
          <!--              <div class="info">-->
          <!--                <span-->
          <!--                  class="top-tag"-->
          <!--                >OFF</span>-->
          <!--                <p class="time">-</p>-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
      </div>
    </section>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import {mapActions, mapState} from 'vuex'
import Sortable from 'sortablejs'
import {getBannerList, sortBanner} from '@api/banner'

export default {
  name: 'index',
  components:{
  },
  mixins: [MixinOptions],
  data() {
    return {
      detailProductList:[],
      promotion_id: ''
    }
  },
  computed:{
    hasData(){
      return this.detailList.length != 0
    },
    hasProductData(){
      return this.detailProductList.length != 0
    },
    hasProductAdData(){
      return this.detailProductADList.length != 0
    }
  },
  mounted(){
    this.network().getBannerList()
    let productEl = this.$refs['sortableBanner']
    this.createProductSort(productEl)
  },
  methods: {
    routerToProductPromoDetail(val){
      let {id} = val||{}
      this.$router.push({
        name: 'HomeBannerDetail',
        query:{
          id,
        }
      })
    },
    handleProductMouseLeave() {
      // 鼠标进入图标控制拖拽开启
      this.bannerSortable.option('disabled', true)
    },
    handleProductMouseEnter() {
      // 鼠标离开图标控制拖拽关闭
      this.bannerSortable.option('disabled', false)
    },
    handleProductClick(val) {
      this.promotion_id = val.id
    },
    sortProductEnd(e) {
      // 拖拽完成执行
      if(e.oldIndex != e.newIndex){
        let params = {
          id: this.promotion_id,
          old_index: e.oldIndex,
          new_index: e.newIndex,
          hideLoading:false
        }
        this.network().sortBanner(params)
      }
    },
    createProductSort(el){
      this.bannerSortable = new Sortable(el,{
        disabled: true,
        onEnd: this.sortProductEnd
      })
    },
    network(){
      return {
        getBannerList: async () => {
          const {data} = await getBannerList({hideLoading:false})
          if(Array.isArray(data)){
            this.detailProductList = data
          }else{
            this.detailProductList = []
          }
        },
        sortBanner: async (params) => {
          const {data} = await sortBanner(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
          }
          await this.network().getBannerList()
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.news-container {
  .header{
    position: relative;
    .title{
      font-weight: 600;
      font-size: 24px;
      height: 36px;
      line-height: 36px;
      letter-spacing: 0.3px;
      color: #24292E;
      margin-bottom: 15px;
    }
    .btn{
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .content-container{
    display: flex;
    flex-wrap: wrap;
    .item{
      margin:0 20px 20px 0;
      .img{
        cursor: pointer;
        height: 112px;
        width: 217px;
        border: 1px solid #E1E4E8;
        box-sizing: border-box;
        border-radius: 6px;
        margin: 10px 0px;
        position: relative;
        img{
          width: 100%;
          height: 100%;
        }
        .add-icon {
          width: 100%;
          height: 100%;
          &::before {
            position: absolute;
            content: "";
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px;
            height: 1px;
            background: #E1E4E8;
          }
          &::after {
            position: absolute;
            content: "";
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 1px;
            height: 50px;
            background: #E1E4E8;
          }
        }
      }
      .top-tag{
        border:1px solid #E1E4E8;
        color: $dark;
        padding: 2px 8px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;

      }
      .footer{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .info{
          p{
            width: 182px;
          }
          .item_title{
            font-family: Inter;
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 18px;
            color: #24292E;
            overflow-wrap: break-word;
            span + span{
              margin: 0 10px;
            }
          }
          .time{
            font-family: Inter;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 18px;
            color: #6A737D;
          }
          .private{
            color: rgba(88, 96, 105, 1);
            font-size: 12px;
            line-height: 18px;
            font-weight: 600;
            border: 1px solid rgba(225, 228, 232, 1);
            // width: 58px;
            height: 18px;
            border-radius: 100px;
            padding: 0 8px;
            margin: 0 !important;
          }
        }
        .icon{
          width: 16px;
          font-style: normal;
          font-weight: 900;
          font-size: 16px;
          line-height: 20px;
          color: #D1D5DA;
          flex: 1;
          text-align: center;
          padding: 8px;
        }
      }
    }
  }
  .no_data{
    line-height: 60px;
    color: #909399;
    text-align: center;
  }
}
.filter-top-select{
  margin-bottom: 15px;
  border-bottom: 1px solid #E1E4E8;
  //padding-bottom: 16px;
  display: flex;
  span{
    padding: 12px 16px 10px 16px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #586069;
    display: block;
    cursor: pointer;
    &.is_active{
      color: #24292E;
      border: 1px solid #E1E4E8;
      border-bottom: 0;
      background: #f8f8f8;
      margin-bottom: -1px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    &:first-child{
      margin-left: 10px;
    }
  }
}
</style>
